// extracted by mini-css-extract-plugin
module.exports = {"content":"_35Hga","day":"_29oNe","past":"p4EWW","dayText":"bVnAE","today":"_2lN0s","events":"_16ZYp","event":"_3T2rN"};